import { Dispatch } from 'react';
import { IBreadcrumbs } from '../../../components/molecules/Breadcrumbs';
import getFlagValue, { FLAG_ENUM } from '../../utils/getFlagValue';
import { addQueueGlobalCount } from '../../../store/emarsys/action';
import { PAGE_NAME_BRANCH_SALES } from '../../../constants/emarsys/branch-sales';

interface Props {
  dispatch: Dispatch<any>;
  customerNo: string;
  breadcrumbItems: IBreadcrumbs[];
  pageName: string;
  pageTitle: string;
  sectionName: string;
  buttonName: string;
  newParams?: Record<string, string | number | boolean>;
}

export default function eventClickDetailBranchSales({
  dispatch,
  customerNo,
  breadcrumbItems,
  pageName,
  pageTitle,
  sectionName,
  buttonName,
  newParams,
}: Props) {
  const isFlagActive = getFlagValue(FLAG_ENUM.EMARSYS);
  const isSalesAdvisorPageName = pageName === PAGE_NAME_BRANCH_SALES.SALES_ADVISOR;
  const isBranchSalesActive =
    !isSalesAdvisorPageName && getFlagValue(FLAG_ENUM.EMARSYS_BRANCH_SALES);
  const isBranchSalesAdvisorActive =
    isSalesAdvisorPageName && getFlagValue(FLAG_ENUM.EMARSYS_BRANCH_SALES_SALES_ADVISOR);
  if (!isFlagActive || (!isBranchSalesActive && !isBranchSalesAdvisorActive)) return;

  if (customerNo) {
    ScarabQueue.push(['setCustomerId', customerNo]);
  }

  const valueClickAction: Record<string, string | number | boolean> = {
    page_name: pageName ?? '',
    page_title: pageTitle ?? '',
    page_url: window.location.href,
    section_name: sectionName ?? '',
    button_name: buttonName ?? '',
    menu_cat_lvl1: breadcrumbItems?.[1]?.name?.toUpperCase() || '',
    ...newParams,
  };

  ScarabQueue.push(['tag', 'click_button', valueClickAction]);
  dispatch(addQueueGlobalCount());
}
